<template>
  <div>
    <Header></Header>
    <div id="main">
      <div class="container">
        <div class="row">
          <div class="col-md-8 offset-md-2">
            <div v-if="showMsg" class="alert alert-danger alert-dismissible fade show" role="alert">
              {{msg}}
              <button type="button" class="close" data-dismiss="alert" aria-label="Fechar" v-on:click.stop.prevent="hideMsg()">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div v-if="showMsgSuccess" class="alert alert-success alert-dismissible fade show" role="alert">
              {{msgSuccess}}
              <button type="button" class="close" data-dismiss="alert" aria-label="Fechar" v-on:click.stop.prevent="hideMsg()">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <form class="preference-form">
              <carousel ref="firstaccess-carousel" class="carousel" :autoplay=false :perPage=1 :paginationEnabled=false>

                <slide class="slide">
                  <h1 v-if="fullname">Olá {{fullname}}, bem-vindo(a) à Click2giv!</h1>
                  <h4>Antes de começarmos, gostariamos de saber: Quais são os tipos de projetos sociais que tocam o seu coração?
                    (Escolha pelo menos uma opção abaixo)</h4>

                  <b-form-group>
                    <b-form-checkbox-group id="checkbox-group-1" v-model="selectedCategories" name="flavour-2" stacked>
                      <b-form-checkbox v-for="(c, k) in arrCategoriesWithMessages" size="lg" v-model="selectedCategories" :value="c.categories" :key="k">{{ c.message }}</b-form-checkbox>
                    </b-form-checkbox-group>
                  </b-form-group>

                  <button type="submit" class="btn" v-on:click.stop.prevent="nextSlide()">Próximo</button>
                </slide>

                <slide class="slide">
                  <h1 v-if="fullname">Olá {{fullname}}, bem-vindo(a) à Click2giv!</h1>
                  <h4>
                    Você pode contribuir com uma Organização Social através de algum conhecimento que você tenha,
                    alguma habilidade, especialização, e assim ajudar a transformar a vida de milhares de pessoas. <br>
                    Escolha na lista abaixo as habilidades que você possui e que gostaria de disponibilizar para uma Organização Social.
                    Identificaremos uma ONG que necessita deste apoio e colocaremos vocês em contato.
                  </h4>

                  <b-form-group>
                    <b-form-radio-group id="checkbox-group-2" v-model="selectedHability" name="flavour-2" stacked>
                      <b-form-radio v-for="(c, k) in arrHabilitiesWithMessages" size="lg" :value="c.hability" :key="k">{{ c.message }}</b-form-radio>
                    </b-form-radio-group>
                  </b-form-group>

                  <button type="submit" class="btn" v-on:click.stop.prevent="lastSlide()">Próximo</button>
                </slide>

                <slide class="slide">
                  <h4>Também gostariamos de saber: quais tipos de loja mais lhe agradam?
                    (Escolha pelo menos uma opção abaixo)</h4>

                  <b-form-group>
                    <b-form-checkbox-group id="checkbox-group-3" v-model="selectedStoreCategories" name="flavour-2" stacked>
                      <b-form-checkbox v-for="c in storeCategories" size="lg"
                        v-model="selectedStoreCategories" :value="c.categoryId" :key="c.categoryId">{{ c.categoryName }}</b-form-checkbox>
                    </b-form-checkbox-group>
                  </b-form-group>

                  <button type="submit" class="btn" v-on:click.stop.prevent="register()">Salvar Preferências</button>
                </slide>
              </carousel>

            </form>

          </div>
        </div>
      </div>
    </div>
    <Footer></Footer>
    <Loading v-if="loading"></Loading>
  </div>
</template>

<script>

import Header from './includes/Header'
import Footer from './includes/Footer'
import Loading from './includes/Loading'
import { Carousel, Slide } from 'vue-carousel';
import auth from '../services/auth'
import Functions from '../utils/functions'
import { API } from '../services/api'
import constants from '../services/constants';

export default {
  name: 'Signup',
  components: {
    Header,
    Footer,
    Loading,
    Carousel,
    Slide
  },
  data () {
    return {
      fullname: null,
      arrHabilitiesWithMessages: [
        {
          'message': 'Sou advogado(a), tenho conhecimento de contratos',
          'hability': 'advogado'
        },
        {
          'message': 'Sou empreendedor(a), posso contribuir com uma palestra sobre este tema e suas habilidades',
          'hability': 'empreendedor'
        },
        {
          'message': 'Sou criativo(a), quero contribuir com idéias e soluções, posso contribuir também com copy',
          'hability': 'criacao'
        },
        {
          'message': 'Sou programador(a), tenho disponibilidade para desenvolver e integrar APIs',
          'hability': 'programador'
        },
        {
          'message': 'Sou designer, posso ajudar na criação de templates e apresentações',
          'hability': 'designer'
        },
        {
          'message': 'Trabalho com tecnologia, conheçø várias ferramentas gratuitas de gestão e colaboração',
          'hability': 'ti'
        },
        {
          'message': 'Trabalho como redator(a), possuo boas habilidades de escrita e textuais',
          'hability': 'redator'
        },
        {
          'message': 'Sou palestrante, estou disponível para uma palestra presencial ou online',
          'hability': 'palestrante'
        },
        {
          'message': 'Trabalho com marketing digital, quero contribuir com esta habilidade',
          'hability': 'marketing'
        },
        {
          'message': 'Sou influenciador(a), quero divulgar uma ONG e ajudá-la na captação de recursos',
          'hability': 'influencer'
        },
      ],
      arrCategoriesWithMessages: [
        {
          'message': 'Aqueles que atuam na proteção e desenvolvimento de crianças',
          'categories': ['criancas', 'educacao', 'social']
        },
        {
          'message': 'Projetos que promovem o desenvolvimento através do esporte',
          'categories': ['esporte', 'saude', 'educacao']
        },
        {
          'message': 'Aqueles que promovem a educação e a cultura',
          'categories': ['educacao', 'cultura', 'social']
        },
        {
          'message': 'Projetos sociais com foco na promoção da saúde',
          'categories': ['saude', 'deficientes', 'idosos']
        },
        {
          'message': 'Proteção e amparo aos animais',
          'categories': ['animais']
        },
        {
          'message': 'Projetos sociais de amparo e empoderamento feminino',
          'categories': ['mulher', 'saude', 'social']
        },
        {
          'message': 'Projetos sociais que tem como foco amparo à situações de emergência',
          'categories': ['emergencia']
        },
        {
          'message': 'Aqueles que apoiam a manutenção e preservação da natureza',
          'categories': ['natureza']
        }
      ],
      categories: [],
      selectedCategories: [],
      selectedHability: null,
      selectedStoreCategories: [],
      storeCategories: null,
      showMsgSuccess: false,
      msgSuccess: "",
      showMsg: false,
      msg: "",
      loading: false
    }
  },
  created(){
    this.loadProfile();
    this.storeCategories = constants.STORE_CATEGORIES;
    this.storeCategories.sort(function(a, b){
      if(a.categoryName < b.categoryName) { return -1; }
      if(a.categoryName > b.categoryName) { return 1; }
      return 0;
    })
  },
  methods: {
    loadProfile(){
      this.$http.get(API.Profile.profile, {headers: auth.getHeaders()}).then((response) => {
        var arrName = response.body.user.Info.fullname.split(' ');
        this.fullname = arrName[0];
        this.loading = false;
      });
    },
    loadCategories(){
      this.$http.get(API.Projects.categories).then((result) => {
        this.loading = false
        this.categories = result.body;
      });
    },
    nextSlide()
    {
      this.$refs['firstaccess-carousel'].goToPage(1);
    },
    lastSlide()
    {
      this.$refs['firstaccess-carousel'].goToPage(2);
    },
    register(){
      var selectedCategories = this.selectedCategories.filter((value, index) => {
         return this.selectedCategories.indexOf(value) === index;
      });
      this.showMsg = false;
      this.loading = true;
      if(this.selectedCategories.length > 0){
        this.$http.post(API.Profile.profileUpdate, {favoritedCategories: selectedCategories, favoritedStoreCategories: this.selectedStoreCategories, hability: this.selectedHability,
          formType: 'updateCategories'}, {headers: auth.getHeaders()}).then((response) => {
            if(response.body.success === false){
              this.showMessage(response.body.message);
            }else{
              this.$router.push('/dashboard');
              this.terms = null;
            }
            this.loading = false;
          }, (error) => {
            console.log("ERROR")
            this.showMessage(error.body.message);
            this.loading = false;
          });
      }else{
        this.msg = "Você deve selecionar pelo menos uma opção!";
        this.showMsg = true;
        this.loading = false;
      }
    },
    showMessage(msg){
        this.msg = msg;
        this.showMsg = true;
    },
    hideMsg(){
        this.msg = "";
        this.showMsg = false;
        this.msgSuccess = "";
        this.showMsgSuccess = false;
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

  .preference-form{
    width: 100%;
    padding: 20px;
    background-color: #fff;
    margin-bottom: 40px;
    font-family: RalewayRegular;

    input{
      padding: 10px;
      border-color: #00ae39;
    }

    h1{
      color: #00ae39;
      font-size: 30px;
    }

    h4{
      margin-top: 20px;
    }

    .form-check{
      padding-bottom: 10px;
    }

    .custom-checkbox, .custom-radio{
      padding: 10px;
      margin-left: 20px;
      font-size: 20px;
    }

    button{
      width: 100%;
      margin-top: 20px;
      padding: 10px;
      font-size: 20px;
      background-color: #00ae39;
      color: #fff;
      cursor: pointer;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/FirstAccess.vue